<template>
 <div class="payMethod">
    <div class="pax__item" v-for="(item, index) in listPayMethods" :key="index">
      <img :src="item.src" :alt="item.name" width="100" height="40" />
    </div>
 </div>
</template>
<script>
export default {
  props: {
    listPayMethods: {
      type: Array,
      required: false
    }
  },
};
</script>
<style lang="scss">
.payMethod {
  display: flex;
  justify-content: center;
  margin: 30px 0;
  flex-wrap: wrap;
  gap: 9px;

  @media only screen and (min-width: 576px) {
    gap: 35px;
  }
}
</style>
